window.KTAppSettings = {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1200,
  },
  colors: {
    theme: {
      base: {
        white: "#ffffff",
        primary: "#6993FF",
        secondary: "#E5EAEE",
        success: "#1BC5BD",
        info: "#8950FC",
        warning: "#FFA800",
        danger: "#F64E60",
        light: "#F3F6F9",
        dark: "#212121",
      },
      light: {
        white: "#ffffff",
        primary: "#E1E9FF",
        secondary: "#ECF0F3",
        success: "#C9F7F5",
        info: "#EEE5FF",
        warning: "#FFF4DE",
        danger: "#FFE2E5",
        light: "#F3F6F9",
        dark: "#D6D6E0",
      },
      inverse: {
        white: "#ffffff",
        primary: "#ffffff",
        secondary: "#212121",
        success: "#ffffff",
        info: "#ffffff",
        warning: "#ffffff",
        danger: "#ffffff",
        light: "#464E5F",
        dark: "#ffffff",
      },
    },
    gray: {
      "gray-100": "#F3F6F9",
      "gray-200": "#ECF0F3",
      "gray-300": "#E5EAEE",
      "gray-400": "#D6D6E0",
      "gray-500": "#B5B5C3",
      "gray-600": "#80808F",
      "gray-700": "#464E5F",
      "gray-800": "#1B283F",
      "gray-900": "#212121",
    },
  },
  "font-family": "Roboto Condensed",
};

require("../theme/plugins/plugins.js");

// Keenthemes' plugins
// window.KTUtil = require(' /js/components/util.js');
window.KTUtil = require("../theme/js/components/util.js");

window.KTApp = require("../theme/js/components/app.js");
window.KTCard = require("../theme/js/components/card.js");
window.KTCookie = require("../theme/js/components/cookie.js");
window.KTDialog = require("../theme/js/components/dialog.js");
window.KTHeader = require("../theme/js/components/header.js");
window.KTImageInput = require("../theme/js/components/image-input.js");
window.KTMenu = require("../theme/js/components/menu.js");
window.KTOffcanvas = require("../theme/js/components/offcanvas.js");
window.KTScrolltop = require("../theme/js/components/scrolltop.js");
window.KTToggle = require("../theme/js/components/toggle.js");
window.KTWizard = require("../theme/js/components/wizard.js");
// require('../theme/js/components/datatable/core.datatable.js');
// require('../theme/js/components/datatable/datatable.checkbox.js');
// require('../theme/js/components/datatable/datatable.rtl.js');

// Metronic layout base js
window.KTLayoutAside = require("../theme/js/layout/base/aside.js");
window.KTLayoutAsideMenu = require("../theme/js/layout/base/aside-menu.js");
window.KTLayoutAsideToggle = require("../theme/js/layout/base/aside-toggle.js");
window.KTLayoutBrand = require("../theme/js/layout/base/brand.js");
window.KTLayoutContent = require("../theme/js/layout/base/content.js");
window.KTLayoutFooter = require("../theme/js/layout/base/footer.js");
window.KTLayoutHeader = require("../theme/js/layout/base/header.js");
// window.KTLayoutHeaderMenu = require('../theme/js/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require("../theme/js/layout/base/header-topbar.js");
window.KTLayoutStickyCard = require("../theme/js/layout/base/sticky-card.js");
window.KTLayoutStretchedCard = require("../theme/js/layout/base/stretched-card.js");
// window.KTLayoutSubheader = require('../theme/js/layout/base/subheader.js');

// Metronic layout extended js
// window.KTLayoutChat = require('../theme/js/layout/extended/chat.js');
// window.KTLayoutDemoPanel = require('../theme/js/layout/extended/demo-panel.js');
// window.KTLayoutExamples = require('../theme/js/layout/extended/examples.js');
// window.KTLayoutQuickActions = require('../theme/js/layout/extended/quick-actions.js');
// window.KTLayoutQuickCartPanel = require('../theme/js/layout/extended/quick-cart.js');
// window.KTLayoutQuickNotifications = require('../theme/js/layout/extended/quick-notifications.js');
// window.KTLayoutQuickPanel = require('../theme/js/layout/extended/quick-panel.js');
// window.KTLayoutQuickSearch = require('../theme/js/layout/extended/quick-search.js');
// window.KTLayoutQuickUser = require('../theme/js/layout/extended/quick-user.js');
window.KTLayoutScrolltop = require("../theme/js/layout/extended/scrolltop.js");
// window.KTLayoutSearch = window.KTLayoutSearchOffcanvas = require('../theme/js/layout/extended/search.js');
